module.exports = __webpack_public_path__ + "img/error.120cc167.png";